import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { Observable, lastValueFrom } from "rxjs";
import { environment } from "../../../../environments/environment";
import { User, RegistrationUser, ConfirmForgotPasswordDto, ForgotPasswordDto } from "../../../models/user.model";
import { superAdminHttpRoutes, superAdminHttpVersion } from "../../../consts/super_admin_http_routes";
import { ApiService } from "../api.services";
import { localStorageConstants } from "../../../consts/local_storage_constants";


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private url: string = superAdminHttpVersion.V1;
  isLoading = false;

  constructor(private _httpClient: HttpClient, private apiService: ApiService,
    private _router: Router,
    private _cookieService: CookieService) {
  }
  signIn(user: User): Observable<any> {
    return this._httpClient.post(`${this.url}/login`, user)
  }

  signUp(user: User): Observable<any> {
    return this.apiService.httpPostCallWithoutToken(`${this.url}${superAdminHttpRoutes.SIGN_UP}`, user)

  }
  signUpEmployee(user: RegistrationUser, token: string): Observable<any> {
    return this._httpClient.post(`${this.url}/signup/${token}/employees`, user)
  }
  signUpUserLicense(user: RegistrationUser, token: string): Observable<any> {
    return this._httpClient.post(`${this.url}/signup/${token}/users`, user)
  }
  confirmSignUp(token: string): Observable<any> {
    return this._httpClient.post(`${this.url}/signup/${token}/confirm`, {})
  }
  confirmSignUpCompany(token: string, password: ConfirmForgotPasswordDto): Observable<any> {
    return this._httpClient.post(`${this.url}/signup/${token}/companies`, password);
  }
  forgotPass(forgotPasswordDto: ForgotPasswordDto): Observable<any> {
    return this._httpClient.post(`${this.url}/forgot-password`, forgotPasswordDto)
  }
  confirmForgotPass(token: string, confirmForgotPasswordDto: ConfirmForgotPasswordDto): Observable<any> {
    return this._httpClient.post(`${this.url}/forgot-password/${token}/confirm`, confirmForgotPasswordDto)
  }
  async isSessionExpired() {
    return await lastValueFrom(this._httpClient.get(`${this.url}/validate`, { withCredentials: true }));
  }
  // Add this in your component class

  logOut() {
    this.isLoading = true; // Start loading

    this._cookieService.delete('access_token');
    localStorage.removeItem(localStorageConstants.SUPER_ADMIN_TOKEN);
    localStorage.removeItem(localStorageConstants.SUPER_ADMIN_DATA);
    localStorage.removeItem(localStorageConstants.USER_TYPE);
    localStorage.removeItem(localStorageConstants.SUPER_ADMIN_LOGGED_IN);
    sessionStorage.removeItem(localStorageConstants.USER_TYPE);

    setTimeout(() => {
      localStorage.setItem(localStorageConstants.SUPER_ADMIN_LOGGED_IN, 'false');
      this.isLoading = false; // End loading
      this._router.navigate(['/superadmin/login'], { queryParams: { fullClose: false } });
    }, 1000);
  }

  portalLogOut() {
    this.isLoading = true; // Start loading

    this._cookieService.delete('access_token');
    localStorage.removeItem(localStorageConstants.PORTAL_TOKEN);
    localStorage.removeItem(localStorageConstants.USER_TYPE);
    localStorage.removeItem(localStorageConstants.PORTAL_LOGGED_IN);
    sessionStorage.removeItem(localStorageConstants.USER_TYPE);

    setTimeout(() => {
      localStorage.setItem(localStorageConstants.PORTAL_LOGGED_IN, 'false');
      this.isLoading = false; // End loading
      this._router.navigate(['/login'], { queryParams: { fullClose: false } });
    }, 1000);
  }

}
